export const mockData = {
  services: [
    {
      id: 1,
      title: "Supplier Selection",
      description: "We identify and validate fully reliable manufacturers in China that meet your specific needs and quality standards.",
      icon: "Factory",
      link: "#supplier-selection"
    },
    {
      id: 2,
      title: "Product Development",
      description: "We transform your idea into a viable product with the highest standards and guarantees from concept to production.",
      icon: "Settings",
      link: "#product-development"
    },
    {
      id: 3,
      title: "Quality Control",
      description: "We supervise every stage of production to ensure compliance and excellence in the products we manufacture.",
      icon: "Search",
      link: "#quality-control"
    },
    {
      id: 4,
      title: "Logistics Management",
      description: "We coordinate the entire supply chain for efficient and successful imports from China to your warehouse.",
      icon: "Ship",
      link: "#logistics"
    }
  ],

  projects: [
    {
      id: 1,
      title: "ELECTRONICS",
      image: "https://static.prod-images.emergentagent.com/jobs/1e377d72-35c9-4698-8603-668ab4051cd7/images/2ffa36df47635a82cc78b708b89f2f14ef4f681e24f8060643e393803876724e.jpeg",
      category: "electronics",
      products: [
        { name: "Solar Panel Systems", description: "High-efficiency mono & polycrystalline solar panels for residential and commercial applications" },
        { name: "Electric Bikes & Scooters", description: "Foldable e-bikes and smart scooters with GPS tracking and long-lasting batteries" },
        { name: "LED Solar Street Lights", description: "All-in-one solar street lighting systems with motion sensors and remote control" },
        { name: "Portable Solar Power Banks", description: "High-capacity solar charging stations for outdoor and emergency applications" },
        { name: "Smart Home Devices", description: "WiFi-enabled thermostats, smart plugs, and voice control systems for modern homes" }
      ]
    },
    {
      id: 2,
      title: "MACHINERY",
      image: "https://static.prod-images.emergentagent.com/jobs/1e377d72-35c9-4698-8603-668ab4051cd7/images/e8a3c3eeea121ae18203a0bce839c6f961c27ea10d780a00d9c52d912bc9e102.jpeg",
      category: "machinery",
      products: [
        { name: "CNC Machining Centers", description: "3-5 axis precision machining equipment for manufacturing and prototyping" },
        { name: "Industrial Conveyor Systems", description: "Automated belt conveyor lines for packaging, assembly, and material handling" },
        { name: "Hydraulic Press Machines", description: "Heavy-duty hydraulic presses for metal forming and industrial applications" },
        { name: "Pneumatic Tools & Components", description: "Complete pneumatic systems including compressors, cylinders, and fittings" },
        { name: "Welding Equipment", description: "Professional MIG/TIG welders, plasma cutters, and welding accessories" }
      ]
    },
    {
      id: 3,
      title: "TOOLS",
      image: "https://static.prod-images.emergentagent.com/jobs/1e377d72-35c9-4698-8603-668ab4051cd7/images/e7be7d4dd3a5e8caa25d0e71f0ab8b4024635086ab1a3306e27ddc45efd43106.jpeg",
      category: "tools",
      products: [
        { name: "Precision Measuring Equipment", description: "Digital calipers, micrometers, and dial indicators for accurate measurements" },
        { name: "Industrial Tool Sets", description: "Comprehensive mechanic and electrician tool kits for professional use" },
        { name: "Power Tool Accessories", description: "High-quality drill bits, saw blades, and grinding wheels for various materials" },
        { name: "Hand Tools", description: "Durable wrenches, screwdrivers, pliers, and hex keys for daily operations" },
        { name: "Safety Equipment", description: "Professional safety glasses, gloves, hard hats, and hearing protection" }
      ]
    },
    {
      id: 4,
      title: "PACKAGING",
      image: "https://static.prod-images.emergentagent.com/jobs/1e377d72-35c9-4698-8603-668ab4051cd7/images/0fd6b3284fbb213ca663280fd2c56fdbe44fa8e614a9f2fcc9df675b2084a8de.jpeg",
      category: "packaging",
      products: [
        { name: "Automatic Packaging Machines", description: "Form-fill-seal machines for food, pharmaceutical, and consumer goods packaging" },
        { name: "Labeling & Printing Systems", description: "Industrial label printers and coding machines for product identification" },
        { name: "Sealing Equipment", description: "Heat sealers, vacuum sealers, and automated tape dispensing systems" },
        { name: "Corrugated Boxes & Cartons", description: "Custom printed shipping boxes and cartons in various sizes and specifications" },
        { name: "Protective Packaging", description: "Bubble wrap, foam inserts, air pillows, and cushioning materials" }
      ]
    },
    {
      id: 5,
      title: "CONSUMER GOODS",
      image: "https://static.prod-images.emergentagent.com/jobs/1e377d72-35c9-4698-8603-668ab4051cd7/images/2694dc3abd3759e4eec62a7012d487cf90add73ed2bceabe7f78355346baa15f.jpeg",
      category: "consumer",
      products: [
        { name: "Smart Home Appliances", description: "Robot vacuums, air purifiers, and smart thermostats for modern living" },
        { name: "Flat-Pack Furniture", description: "Ready-to-assemble desks, chairs, and storage systems for home and office" },
        { name: "Kitchen Gadgets", description: "Air fryers, electric kettles, food processors, and innovative cooking tools" },
        { name: "Fitness Accessories", description: "Yoga mats, resistance bands, water bottles, and workout equipment" },
        { name: "Phone Accessories", description: "Protective cases, wireless chargers, earbuds, and device stands" }
      ]
    },
    {
      id: 6,
      title: "TEXTILES",
      image: "https://static.prod-images.emergentagent.com/jobs/1e377d72-35c9-4698-8603-668ab4051cd7/images/aa5c97982e130a1b693c5b3985386974ec0cc37ba7bf1beabfd07573ea7943b0.jpeg",
      category: "textiles",
      products: [
        { name: "Technical Fabrics", description: "Fire-resistant, waterproof, and anti-bacterial textiles for specialized applications" },
        { name: "Sustainable Clothing", description: "Organic cotton, bamboo fiber, and recycled polyester garments" },
        { name: "Home Textiles", description: "Premium bed sheets, curtains, tablecloths, and decorative fabrics" },
        { name: "Workwear & Uniforms", description: "Professional clothing, safety vests, aprons, and corporate uniforms" },
        { name: "Basic Cotton Products", description: "High-quality t-shirts, towels, socks, and everyday apparel items" }
      ]
    },
    {
      id: 7,
      title: "APPAREL & BABY PRODUCTS",
      image: "https://static.prod-images.emergentagent.com/jobs/1e377d72-35c9-4698-8603-668ab4051cd7/images/3938419d88bc8f4da8275f28b10ebce086e2e3df30aade91532122700fc17fdb.jpeg",
      category: "apparel",
      products: [
        { name: "Baby Products & Accessories", description: "Baby clothes, diapers, feeding bottles, strollers, car seats, and safety products" },
        { name: "Kids Clothing & Footwear", description: "Children's apparel, school uniforms, sneakers, and seasonal clothing collections" },
        { name: "Adults Fashion Clothing", description: "Men's and women's casual wear, business attire, sportswear, and fashion accessories" },
        { name: "Maternity & Nursing Wear", description: "Comfortable maternity clothing, nursing bras, and postpartum recovery garments" },
        { name: "Seasonal Collections", description: "Winter coats, summer wear, swimwear, and holiday-themed clothing for all ages" },
        { name: "Footwear & Accessories", description: "Shoes, boots, handbags, belts, hats, and fashion jewelry for men, women, and children" }
      ]
    }
  ],

  blogPosts: [
    {
      id: 1,
      title: "Strategic Sourcing in China: Maximizing ROI in 2024",
      excerpt: "Learn how to optimize your sourcing strategy in China for maximum return on investment with our proven methodologies.",
      image: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2340&q=80",
      date: "15 Dec, 2024",
      category: "Strategy"
    },
    {
      id: 2,
      title: "Quality Control: Ensuring Excellence in Chinese Manufacturing",
      excerpt: "Discover the essential quality control measures that guarantee product excellence when sourcing from Chinese manufacturers.",
      image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2187&q=80",
      date: "28 Nov, 2024",
      category: "Quality"
    },
    {
      id: 3,
      title: "Building Long-term Partnerships with Chinese Suppliers",
      excerpt: "Strategies for developing sustainable and profitable relationships with manufacturing partners in China.",
      image: "https://images.unsplash.com/photo-1600880292203-757bb62b4baf?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2340&q=80",
      date: "10 Nov, 2024",
      category: "Partnerships"
    }
  ],

  offices: [
    {
      city: "Xiamen",
      country: "China",
      phone: "+86 15381939338",
      email: "office@towertech-xm.com",
      address: "Fujian Province, China"
    }
  ],

  faqs: [
    {
      question: "What regions do you operate in?",
      answer: "We are based in China and support clients worldwide with sourcing, supplier management, quality control and international delivery from China."
    },
    {
      question: "Do you offer custom product development?",
      answer: "Yes. We take care of the development and supervision of each stage so that your product meets your requirements and quality standards, from concept to final production."
    },
    {
      question: "How do you guarantee product quality?",
      answer: "We carry out comprehensive factory inspections and audits, ensuring that each production run complies with the agreed standards before shipment. Our quality control team is based in China for real-time monitoring."
    },
    {
      question: "Do you provide shipping and logistics management?",
      answer: "We coordinate all logistics management with suppliers and carriers to ensure efficient importation from China to your warehouse, handling customs, documentation, and delivery coordination."
    }
  ]
};